import { Injectable, signal } from '@angular/core';
declare const google: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleService {

  isSigningIn = signal(false);
  private _onToken: ( token:string ) => void = () => {};
  set onToken(fn: ( token:string ) => void) {
    this._onToken = (token) => {
      this.isSigningIn.set(false);
      fn(token);
    };
  }

  private initialized = false;

  init() {
    if(this.initialized)
      return;
    this.initialized = true;
    google.accounts.id.initialize({
      client_id: "50931287988-jnrqum2ai7bhr2ujnq76hompgdng5abn.apps.googleusercontent.com",
      scope: 'https://www.googleapis.com/auth/cloud-identity.users,https://www.googleapis.com/auth/admin.directory.user,https://www.googleapis.com/auth/cloud-identity.groups',
      callback: (r: any) => this._onToken(r.credential)
    });
  }

  signInToGoogle() {
    this.isSigningIn.set(true);
    try {
      google.accounts.id.prompt();
    } catch (e) {
      console.log(e)
    }
  }

  renderButton(element: HTMLElement) {
    google.accounts.id.renderButton(
      element,
      { theme: 'outline', size: 'large' }  // customization attributes
    );
  }

}
